import { fetchSavedDocuments, selectSavedDocuments, selectSavedDocumentsFirstLoad, selectSavedDocumentsLoading } from "@/entities/aviabooking-saved-documents"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { memo, useEffect } from "react"
import { BookFlightFormValues } from "../../model"
import { useFormContext } from "react-hook-form"
import { PassengerInfoItem } from "../passenger-info-item"

export const PassengersInfo = memo(() => {
    const dispatch = useAppDispatch()
    const savedDocuments = useAppSelector(selectSavedDocuments)
    const savedDocumentsLoading = useAppSelector(selectSavedDocumentsLoading)
    const savedDocumentsFirstLoad = useAppSelector(selectSavedDocumentsFirstLoad)

    const {
        watch,
    } = useFormContext<BookFlightFormValues>()

    const travellers = watch('travellers')

    useEffect(() => { 
        if (savedDocumentsFirstLoad) {
            dispatch(fetchSavedDocuments())
        }
    }, [dispatch, savedDocumentsFirstLoad])

    if (!travellers.length) return null

    return (
        <div className="flex flex-col gap-4">
            {travellers.map((traveller, index) =>
                <PassengerInfoItem
                    key={traveller.id} 
                    traveller={traveller}
                    index={index}
                    savedDocuments={savedDocuments}
                    savedDocumentsLoading={savedDocumentsLoading}
                />
            )} 
        </div>
    )
})